<template>
<div class="chapter">
<div class="inner_page">
<p class="h2">TABLE OF CONTENTS</p>
<p class="toc"><a href="#/xhtml/9780226112428_08_illu">LIST OF ILLUSTRATIONS</a></p>
<p class="toc"><a href="#/xhtml/9780226112428_09_sym">LIST OF SYMBOLS AND SPECIAL CHARACTERS</a></p>
<p class="toc"><a href="#/xhtml/9780226112428_10_ch1">I. <i>ENÛMA ELISH</i></a></p>
<p class="toc"><span href="#/xhtml/9780226112428_11_ch2" title="Link target outside of Sample">II. RELATED BABYLONIAN CREATION STORIES</span></p>
<p class="toc"><span href="#/xhtml/9780226112428_12_ch3" title="Link target outside of Sample">III. OLD TESTAMENT PARALLELS</span></p>
<p class="toc"><span href="#/xhtml/9780226112428_15_not" title="Link target outside of Sample">NOTES</span></p>
<p class="toc"><span href="#/xhtml/9780226112428_13_app" title="Link target outside of Sample">APPENDIX</span><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226112428_07_toc.vue?b010e5ba